import React from 'react';
import './ApproveDeclinePost.css';
import { Button } from '../../elements/buttons/Button';

export const ApproveDeclinePost = ({ onDeclinePost, onAcceptPost }) => {
    return (
        <div className="post__actions">
            <div className="accept" onClick={() => onAcceptPost(true)}>
                +
            </div>
            <div className="decline" onClick={() => onDeclinePost(true)}>
                -
            </div>
        </div>
    );
};
